const swiper = new Swiper('.element-main-swiper', {
    // Optional parameters
    direction: 'horizontal',
    loop: true,
    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    slidesPerView: 3,
    spaceBetween: 50,
    //autoplay:true,
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        320: {
            watchSlidesProgress: true,
            slidesPerView: 1,
            shortSwipes: false
        },
        500: {
            watchSlidesProgress: true,
            slidesPerView: 2,
            shortSwipes: false
        },
        1024: {
            preventInteractionOnTransition: true,
            watchSlidesProgress: true,
            slidesPerView: 3,
            shortSwipes: false
        },
    },

});
